export default __webpack_public_path__ + "static/media/left_highArch.8bfa6545.png";